import { DatePickerInput, DatesRangeValue } from '@mantine/dates';

interface DateRangeFilterProps {
  dateRange: [Date, Date];
  onChange: (dates: [Date, Date]) => void;
}

export function DateRangeFilter({ dateRange, onChange }: DateRangeFilterProps): JSX.Element {
  return (
    <DatePickerInput
      type="range"
      label="Date Range"
      placeholder="Pick dates range"
      defaultValue={dateRange}
      onChange={(dates: DatesRangeValue): void => {
        // Handle partial selection (user clicked first date but not second)
        if (!dates) return;

        if (Array.isArray(dates)) {
          const [start, end] = dates;

          // Only update parent state if both dates are selected
          if (start && end) {
            const startDate = start instanceof Date ? start : new Date(start);
            const endDate = end instanceof Date ? end : new Date(end);
            onChange([startDate, endDate]);
          }
        }
      }}
      maxDate={new Date()}
      clearable={false}
      valueFormat="MMM DD, YYYY"
      allowSingleDateInRange
    />
  );
}
